import { Plus } from "lucide-react";

import { tr } from "@/lib/i18n";
const ICONS = {
  monofalda: <path d="M4 26 L36 26 L36 10 L4 18 Z" />,
  sella: <><path d="M4 26 L36 26 L36 6 L4 6 Z" /><path d="M4 16 L36 16" /></>,
  padiglione: <><path d="M4 26 L36 26 L36 6 L4 6 Z" /><path d="M4 26 L13 16 L27 16 L36 26 M4 6 L13 16 M27 16 L36 6" /></>,
  libero: <><path d="M4 26 L20 26 L20 12 L4 8 Z" /><path d="M20 26 L36 26 L36 14 L20 12" /></>,
};
const SHAPES = [["monofalda", tr("Monofalda")], ["sella", tr("A due falde")], ["padiglione", tr("A padiglione")], ["libero", tr("Libero")]];
const HINT = {
  monofalda: tr("Una falda: disegna il rettangolo (3 clic) o il poligono; la prima linea è la gronda."),
  sella: tr("Disegna il rettangolo dell'edificio (3 clic o da quote): vengono create 2 falde con colmo centrale."),
  padiglione: tr("Disegna il rettangolo dell'edificio (3 clic o da quote): vengono create 4 falde, ognuna con pendenza e orientamento propri."),
  libero: tr("Disegna una falda alla volta con il poligono; i vertici si agganciano a quelli delle falde vicine."),
};

const Deg = ({ label, value, onChange, testid }) => (
  <label className="block"><span className="text-xs text-slate-500">{label}</span>
    <div className="flex items-center mt-0.5 border border-slate-200 rounded-md overflow-hidden">
      <input type="number" min={1} max={75} step={1} value={value ?? ""} data-testid={testid} onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className="w-full px-2.5 h-9 text-sm font-tech outline-none" />
      <span className="px-2 text-xs text-slate-400 bg-slate-50 h-9 flex items-center">°</span>
    </div>
  </label>
);

export const RoofShape = ({ p, update, ed, addRoof }) => {
  const shape = p.roof_shape || "monofalda";
  const sp = p.roof_shape_params || {};
  const setSp = (patch) => update((prev) => ({ roof_shape_params: { pitch: 30, ...(prev.roof_shape_params || {}), ...patch } }));
  const pick = (v) => { update({ roof_shape: v }); ed.setTool(v === "libero" ? "draw-roof" : "draw-rect3"); };
  return (
    <div data-testid="editor-roof-shape">
      <div className="grid grid-cols-4 gap-1.5">
        {SHAPES.map(([v, l]) => (
          <button key={v} data-testid={`editor-roof-shape-${v}`} title={l} onClick={() => pick(v)}
            className={`rounded-md border p-1 flex flex-col items-center gap-0.5 transition-colors ${shape === v ? "border-[#0F52BA] bg-sky-50 text-[#0F52BA]" : "border-slate-200 text-slate-500 hover:border-slate-300"}`}>
            <svg viewBox="0 0 40 32" className="w-10 h-8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round">{ICONS[v]}</svg>
            <span className="text-[10px] leading-tight text-center">{l}</span>
          </button>
        ))}
      </div>
      {(shape === "sella" || shape === "padiglione") && (
        <div className="grid grid-cols-2 gap-2 mt-2">
          <Deg label={tr("Pendenza falde")} value={sp.pitch ?? 30} testid="editor-shape-pitch" onChange={(v) => setSp({ pitch: v })} />
          {shape === "padiglione" && <Deg label={tr("Pendenza testate")} value={sp.hip_pitch ?? sp.pitch ?? 30} testid="editor-shape-hip-pitch" onChange={(v) => setSp({ hip_pitch: v })} />}
        </div>
      )}
      <p className="text-[11px] text-slate-400 mt-1.5" data-testid="editor-roof-shape-hint">{HINT[shape]}</p>
      {shape === "libero" && (
        <button data-testid="editor-add-pitch" onClick={addRoof} className="mt-1.5 h-8 w-full rounded-md border border-dashed border-slate-300 text-slate-600 text-sm flex items-center justify-center gap-1"><Plus className="w-4 h-4" />{tr("Aggiungi falda")}</button>
      )}
    </div>
  );
};
